<template>
 <div class="new-admin">
   <div class="container-fluid">
     <sidebar />
     <div class="col-md-9 col-lg-10 ml-md-auto py-2">
       <div id="scroll" class="header d-flex justify-content-start w-100 align-items-center py-3 mb-5 border-bottom border-dark">
         <h2 class="my-3">新規管理者を登録</h2>
       </div>
      <div v-if="apiStatus">
          {{statusAlert(true)}}
      </div>
      <div v-if="error" class="validation py-3 px-5 my-4">
          <p class="m-0">{{ error }}</p>
      </div>
       <div class="new-admin-form mb-4 p-3 mb-2 bg-light text-dark">
         <b-container fluid>
           <b-form>

              <b-row class="my-3">
                <b-col lg="2" class="align-items-center d-flex">
                  <label class="m-0 required">氏名</label>
                </b-col>
                <b-col lg="4">
                  <b-form-input class="form-input" v-model="$v.user.fullname.$model" placeholder="山田太郎" :state="validateState('fullname')"></b-form-input>
                  <b-form-invalid-feedback :state="validateState('fullname')">
                    <p v-if="!$v.user.fullname.required">氏名は必須です</p>
                    <p v-if="!$v.user.fullname.maxLength">20文字以下で入力してください</p>
                    <p v-if="!$v.user.fullname.minLength">氏名{{$v.user.fullname.$params.minLength.min}}文字以上入力してください</p>
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>

              <b-row class="my-3">
                <b-col lg="2" class="align-items-center d-flex">
                  <label class="m-0 required">ユーザー名</label>
                </b-col>
                <b-col lg="4">
                  <b-form-input class="form-input" v-model="$v.user.user_name.$model" placeholder="yamada001" :state="validateState('user_name')"></b-form-input>
                  <b-form-invalid-feedback :state="validateState('user_name')">
                    <p v-if="!$v.user.user_name.required">ユーザー名は必須です</p>
                    <p v-if="!$v.user.user_name.maxLength">20文字以下で入力してください</p>
                    <p v-if="!$v.user.user_name.minLength">ユーザー名{{$v.user.user_name.$params.minLength.min}}文字以上入力してください</p>
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>

              <b-row class="my-3">
                <b-col lg="2" class="align-items-center d-flex">
                  <label class="m-0 required">メールアドレス</label>
                </b-col>
                <b-col lg="10">
                  <b-form-input class="form-input" autocomplete="off" v-model="$v.user.email_address.$model" placeholder="yamada@globalestate-japan.com/" :state="validateState('email_address')"></b-form-input>
                  <b-form-invalid-feedback :state="validateState('email_address')">
                    <p v-if="!$v.user.email_address.required">メールアドレスを入力してください</p>
                    <p v-if="!$v.user.email_address.email">メールアドレスを正しく入力してください</p>
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>

              <b-row class="my-3">
                <b-col lg="2" class="align-items-center d-flex">
                  <label class="m-0 required">パスワード</label>
                </b-col>
                <b-col lg="4">
                  <b-form-input :type="passwordShowHide" autocomplete="off" v-model="$v.user.password.$model" class="form-input" :state="validateState('password')"></b-form-input>
                  <span class="field-icon" @click="showPassword = !showPassword">
                    <img src="@/assets/img/client/mdi-eye-off.png" alt="" width="33" height="21" v-if="showPassword">
                    <img src="@/assets/img/client/mdi-eye.png" alt="" width="33" height="21" v-else>
                  </span>
                  <b-form-invalid-feedback :state="validateState('password')">
                    <p v-if="!$v.user.password.required">パスワードは必須です</p>
                    <p v-if="!$v.user.password.minLength">パスワード{{$v.user.password.$params.minLength.min}}文字以上入力してください</p>
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>

              <b-row class="my-3">
                <b-col lg="2" class="align-items-center d-flex">
                  <label class="m-0 required">担当エリア</label>
                </b-col>
                <b-col lg="4" class="align-items-center">
                  <b-form-select v-model="$v.user.area_responsibility.$model" class="form-select" :state="validateState('area_responsibility')">
                    <b-form-select-option :value="null" disabled="disabled" selected>選択してください</b-form-select-option>
                    <b-form-select-option value="Yokohama">横浜</b-form-select-option>
                    <b-form-select-option value="Sapporo">札幌</b-form-select-option>
                    <b-form-select-option value="HeadQuarters">本部</b-form-select-option>
                  </b-form-select>
                  <b-form-invalid-feedback :state="validateState('area_responsibility')">
                    <p v-if="!$v.user.password.required">担当エリアは必須です</p>
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>

              <b-row class="my-3">
                <b-col lg="2" class="align-items-center d-flex">
                  <label class="m-0 required">権限</label>
                </b-col>
                <b-col lg="6" class="align-items-center">
                  <b-form-group class="m-0 form-radio-button">
                    <b-form-radio-group class="radios" v-model="$v.user.authority.$model" :state="validateState('authority')">
                      <b-form-radio value="super_authority">スーパー権限</b-form-radio>
                      <b-form-radio value="editorial_rights">編集権限</b-form-radio>
                      <b-form-radio value="posting_permission">投稿権限</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                  <b-form-invalid-feedback :state="validateState('authority')">
                    <p v-if="!$v.user.password.required">権限は必須です</p>
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>
           </b-form>
        </b-container>
       </div>
       <div class="d-flex justify-content-start align-items-center">
         <a href="#scroll" class="text-decoration-none text-white" v-smooth-scroll><b-button class="btn-general py-2 px-5" variant="primary" @click="addNewAdmin">保存</b-button></a>
       </div>
     </div>
   </div>
 </div>
</template>

<script>
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'
import { mapActions, mapState } from 'vuex'
import sidebar from '@/components/_sidebar/sidebar'

export default {
  data () {
    return {
      status: null,
      showPassword: true,
      user: {
        fullname: null,
        user_name: null,
        email_address: null,
        password: null,
        area_responsibility: null,
        authority: null
      },
      error: null
    }
  },
  validations: {
    user: {
      fullname: {
        required,
        minLength: minLength(0),
        maxLength: maxLength(20)
      },
      user_name: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(20)
      },
      email_address: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(8)
      },
      area_responsibility: { required },
      authority: { required }
    }
  },
  created () {
    this.$store.commit('setErrors', null)
    this.$store.commit('setApiStatus', null)
  },
  computed: {
    ...mapState(['apiStatus']),
    passwordShowHide () {
      return this.showPassword ? 'password' : 'text'
    }
  },
  methods: {
    ...mapActions('adminAccount', ['registerAdmin']),
    validateState (name) {
      const { $dirty, $error } = this.$v.user[name]
      return $dirty ? !$error : null
    },
    addNewAdmin: function () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.error = 'エラー：すべてのフィールドを確認して、再試行してください'
      } else {
        this.registerAdmin(this.$v.user.$model)
        this.user = {
          fullname: null,
          user_name: null,
          email_address: null,
          password: null,
          area_responsibility: null,
          authority: null
        }
        this.$nextTick(() => {
          this.$v.$reset()
        })
        this.error = null
      }
    },
    statusAlert (append = false) {
      this.$bvToast.toast('body', {
        title: this.apiStatus,
        toaster: 'b-toaster-top-center',
        solid: true,
        appendToast: append,
        autoHideDelay: 3000
      })
    }
  },
  components: {
    sidebar
  }
}
</script>
